module.exports = {
  "country": "HR",
  "artist": "Let 3 ",
  "song": "Mama ŠČ!",
  "year": "2023",
  "place": "13",
  "spotify": "7hcPebUUvJDRH6BhjZ5xEZ"
};